/**
 * Client-side permission check (ADR-0010). The server is always the real gate —
 * this only decides what to show. `*` is the owner wildcard.
 */

import type { Permission } from './types.js';

export function hasPermission(held: readonly Permission[], wanted: Permission): boolean {
  return held.includes('*') || held.includes(wanted);
}

/**
 * What a demo administrator's console covers (`CurrentUser.restrictedView`), mirroring the routes the
 * backend's `RestrictDemoAdmin` leaves open to it: its own (and shared) layouts, media, displays and
 * groups. Its role holds more, but the server refuses the rest, so the console doesn't offer it.
 */
export const RESTRICTED_VIEW_PERMISSIONS: readonly Permission[] = [
  'displays.view',
  'displays.manage',
  'displays.command',
  'media.view',
  'media.manage',
  'layouts.view',
  'layouts.edit',
  'layouts.publish',
  'schedule.view',
  'schedule.edit',
  'modules.view',
];

/** The permissions the console acts on: all of [held], or in a restricted view only its part of them. */
export function effectivePermissions(held: readonly Permission[], restrictedView: boolean): Permission[] {
  return restrictedView ? RESTRICTED_VIEW_PERMISSIONS.filter((p) => hasPermission(held, p)) : [...held];
}
